import React from 'react';

class AnswerItems extends React.Component {

    handleChange = (e) => {
        let _this = e.target;
        this.props.HandleAnswers(_this.id, _this.getAttribute('data-Type'), _this.checked);
    }

    render() {
        const { Type, Text, Id, QuestionId } = this.props;
        // 0=radiobutton ,1=checkbox
        let type = Type == "0" ? "radio" : "checkbox";
        return (
            <React.Fragment>
                <div className={'custom-control custom-' + type}>
                    <input type={type} className="custom-control-input"
                        id={Id}
                        name={type + QuestionId}
                        value={Text}
                        data-type={Type}
                        onChange={this.handleChange} />
                    <label className="custom-control-label" htmlFor={'custom' + type}>{Text} </label>
                </div>
            </React.Fragment>
        );
    };
}

export default AnswerItems;


// WEBPACK FOOTER //
// ./src/Components/Requests/com.answerItems.jsx